import {Component, OnInit} from '@angular/core';
import {DocumentService} from '../../services/document.service';
import {ActivatedRoute} from '@angular/router';
import {saveAs} from 'file-saver';
import {Document} from '../../models/document';

@Component({
  selector: 'app-download-document',
  templateUrl: './download-document.component.html',
  styleUrls: ['./download-document.component.scss']
})
export class DownloadDocumentComponent implements OnInit {

  documentUniqid: string;

  constructor(private documentService: DocumentService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.documentUniqid = params.get('documentUniqid');
      if (!this.documentService.downloadInitiated) {
        this.documentService.downloadInitiated = true;
        setTimeout(() => { // this time out is added to synchronise x-switch-user value when impersonating a user
          this.getDocumentByUniqid(this.documentUniqid);
        }, 200);
      }
    });
  }

  private getDocumentByUniqid(documentUniqid) {
    this.documentService.getDocumentByUniqid(documentUniqid).subscribe({
        next: document => {
          if (!document[0]) {
            this.documentService.fileNotFound = true;
            this.redirectionToListDocument();
          } else {
            this.downloadDocument(document[0]);
          }
        },
        error: () => {
          this.documentService.fileNotFound = true;
          this.redirectionToListDocument();
        }
      }
    );
  }

  redirectionToListDocument() {
    this.documentService.downloadInitiated = false;
    location.assign('/#/document');
  }

  downloadDocument(document: Document) {
    this.documentService.downloadDocumentFile(document.uniqid).subscribe({
        next: res => {
          this.documentService.fileNotFound = false;
          this.downLoadFile(res, document.filename);
        },
        error: () => {
          this.documentService.fileNotFound = true;
          this.redirectToListDocument();
        }
      }
    );
  }

  redirectToListDocument() {
    this.documentService.downloadInitiated = false;
    location.assign('/#/document');
  }

  downLoadFile(data: any, fileName: string) {
    const blob = new Blob([data]);
    saveAs(blob, fileName);
    this.redirectToListDocument();
  }
}
